{{ date.day }}


// WEBPACK FOOTER //
// ./node_modules/@ng-bootstrap/ng-bootstrap/datepicker/datepicker-day-view.d.ts.NgbDatepickerDayView.html